import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const DatabaseSecurity: React.FC = () => {
  const sections = [
    {
      title: 'Database Security Solutions',
      content: 'Our database security solutions protect your critical data assets through comprehensive monitoring, access control, and threat detection. We implement multi-layered security controls to protect databases from internal and external threats.',
      benefits: [
        'Database activity monitoring and auditing',
        'Privileged user access control',
        'Data encryption and tokenization',
        'Vulnerability assessment and patching',
        'Compliance reporting and audit support'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Database Security"
      subtitle="Comprehensive database security solutions to protect critical data assets and ensure regulatory compliance."
      sections={sections}
    />
  );
};

export default DatabaseSecurity;

